import { Entity } from "@backstage/catalog-model";
import { ApiHolder, configApiRef } from "@backstage/core-plugin-api";
import { scorecardsEnabled } from "@internal/plugin-front-door-common";

/** `frontDoor.scorecards.enabled`: the checks, the Scorecard tab and the Scorecards page. */
export { scorecardsEnabled };

/**
 * `EntitySwitch.Case` condition for the Scorecard entity tab: true unless
 * `frontDoor.scorecards.enabled` is false.
 */
export function isScorecardsEnabled(
  _entity: Entity,
  context: { apis: ApiHolder }
): boolean {
  const config = context.apis.get(configApiRef);
  return config ? scorecardsEnabled(config) : true;
}
